import { Http } from '@pirates/not-morty-biz';
import { Company } from '../../company.model';
import { Contact, ContactValidation } from '../company-contact-form/company-contact.model';

export class CompanyContactService {
  public async update(id: number, contact: Contact) {
    return Http.put<Company>(`/api/b2b/bo-api/v1/customer/companies/${id}/contact`, contact);
  }

  public async getValidation(id: number) {
    const validation = await Http.get<ContactValidation>(`/api/b2b/bo-api/v1/customer/companies/${id}/contact/validation`);
    delete validation.properties.email.example;
    return validation;
  }
}

export const companyContactService = new CompanyContactService();
